import axios from "axios";
import Config from "src/config";

const getUrl = () => Config.dev ? Config.url_dev : Config.urlBackend;

export const listChatbots = (clienteId) => {
    return axios({
        method: "get",
        url: `${getUrl()}/api/v1/chatbots/cliente/${clienteId}`
    });
};

export const createChatbot = (data) => {
    return axios({
        method: "post",
        url: `${getUrl()}/api/v1/chatbots`,
        data
    });
};

export const getChatbot = (id) => {
    return axios({
        method: "get",
        url: `${getUrl()}/api/v1/chatbots/${id}`
    });
};

export const updateChatbot = (id, data) => {
    return axios({
        method: "put",
        url: `${getUrl()}/api/v1/chatbots/${id}`,
        data
    });
};

export const deleteChatbot = (id) => {
    return axios({
        method: "delete",
        url: `${getUrl()}/api/v1/chatbots/${id}`
    });
};

export const duplicateChatbot = (id) => {
    return axios({
        method: "post",
        url: `${getUrl()}/api/v1/chatbots/${id}/duplicate`
    });
};

export const testChatbotFlow = (chatbotId, data) => {
    return axios({
        method: "post",
        url: `${getUrl()}/flow/internal-prediction/${chatbotId}`,
        data: {
            question: data.question,
            sessionId: data.sessionId,
            streaming: false,
            splitMessages: true,
            vars: data.vars || {},
            history: data.history || []
        }
    });
};

// Chatflow Logs
export const getChatbotLogs = (chatbotId, params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.status) queryParams.append('status', params.status);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);

    return axios({
        method: "get",
        url: `${getUrl()}/api/v1/chatbots/${chatbotId}/logs?${queryParams.toString()}`
    });
};

export const getChatbotLogsStats = (chatbotId, params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);

    return axios({
        method: "get",
        url: `${getUrl()}/api/v1/chatbots/${chatbotId}/logs/stats?${queryParams.toString()}`
    });
};

export const clearChatbotLogs = (chatbotId) => {
    return axios({
        method: "delete",
        url: `${getUrl()}/api/v1/chatbots/${chatbotId}/logs`
    });
};

export const getChatflowLogBySession = (sessionId) => {
    return axios({
        method: "get",
        url: `${getUrl()}/api/v1/chatflow-logs/session/${sessionId}`
    });
};

export const getChatflowLog = (id) => {
    return axios({
        method: "get",
        url: `${getUrl()}/api/v1/chatflow-logs/${id}`
    });
};

export const deleteChatflowLog = (id) => {
    return axios({
        method: "delete",
        url: `${getUrl()}/api/v1/chatflow-logs/${id}`
    });
};
